export class AppConfig {
    public backendUrl: string;
    public backendWebUrl: string;
    public authUrl: string;
    public baseUrl: string;
    public env: string = '';
    public tenant:string='';
    public otpexpiry:number;
}
